/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Credentials_Dialog_Replace_DescriptionInputs */



/**
* | output |
* | --- |
* | "Saving will overwrite the values currently on file." |
*
* @param {Integrations_Credentials_Dialog_Replace_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_dialog_replace_description = /** @type {((inputs?: Integrations_Credentials_Dialog_Replace_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Dialog_Replace_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Speichern werden die aktuell hinterlegten Werte überschrieben.")
	return /** @type {LocalizedString} */ ("Saving will overwrite the values currently on file.")
});